import { Link } from 'react-router-dom';

interface ArticleHeroProps {
  title: string; subtitle: string; category: string;
  date: string; author: string; heat: string;
  image: string; slug: string;
}

export default function ArticleHero({ title, subtitle, category, date, author, heat, image, slug }: ArticleHeroProps) {
  return (
    <section className="relative w-full pt-24 md:pt-32 pb-10 md:pb-16">
      <div className="w-full px-6 md:px-10 max-w-4xl mx-auto flex flex-col items-center">
        <div className="flex items-center gap-3 mb-5">
          <Link to={`/category/${slug}`} className="px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full hover:bg-accent-200 transition-colors font-label">{category}</Link>
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 text-center leading-tight">{title}</h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-foreground-600 text-center max-w-2xl leading-relaxed">{subtitle}</p>
        <div className="flex items-center gap-4 mt-6 md:mt-8 text-xs text-foreground-500 font-label">
          <span className="flex items-center gap-1"><i className="ri-user-line"></i>{author}</span>
          <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{date}</span>
          <span className="flex items-center gap-1"><i className="ri-fire-line text-accent-500"></i>{heat} 热度</span>
        </div>
      </div>
      <div className="w-full px-6 md:px-10 max-w-4xl mx-auto mt-10 md:mt-14">
        <div className="relative w-full rounded-2xl overflow-hidden" style={{ aspectRatio: '16/7' as string }}>
          <img src={image} alt={`51黑料吃瓜网 - ${title}`} title={`51黑料吃瓜网 - ${title}`} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/15 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}